import { StockStatusEnum } from '@petsmart-ui/sparky';

export const getStockLevelAvailability = (stockLevel: StockStatusEnum): string | null =>
    ({
        [StockStatusEnum.InStock]: 'In Stock',
        [StockStatusEnum.FewLeftInStock]: 'Low Stock',
        [StockStatusEnum.OutOfStock]: 'Out of Stock',
        [StockStatusEnum.NotAvailable]: null,
    })[stockLevel];
